/**
 * ============================================
 * PageLoader - 페이지 로딩 컴포넌트
 * ============================================
 *
 * 【설명】
 * React.lazy로 코드 스플리팅된 페이지가 로드되는 동안
 * Suspense의 fallback으로 표시되는 로딩 컴포넌트입니다.
 *
 * 【사용법】
 * import { PageLoader } from './components/PageLoader';
 *
 * <Suspense fallback={<PageLoader />}>
 *   <LazyLoadedPage />
 * </Suspense>
 */

import React from 'react';

/**
 * 페이지 로딩 스피너 컴포넌트
 * @returns {JSX.Element}
 */
export function PageLoader() {
  return (
    <div style={styles.container}>
      <div style={styles.spinner} />
      <p style={styles.text}>페이지 로딩 중...</p>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    minHeight: '200px',
    gap: '16px',
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '3px solid #e5e7eb',
    borderTopColor: '#5a8f7b',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  },
  text: {
    color: '#6b7280',
    fontSize: '14px',
    margin: 0,
  },
};

// CSS keyframes를 동적으로 추가
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = `
    @keyframes spin {
      to { transform: rotate(360deg); }
    }
  `;
  // 중복 추가 방지
  if (!document.querySelector('style[data-pageloader]')) {
    styleSheet.setAttribute('data-pageloader', 'true');
    document.head.appendChild(styleSheet);
  }
}

export default PageLoader;
